export default __webpack_public_path__ + "static/media/image.01feb04d.jpg";